import { useState, useCallback } from 'react';
import { obrasSocialesAPI } from '../../../core/api/api';

export const useRutasObrasSocial = () => {
  const [rutas, setRutas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const cargarRutas = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await obrasSocialesAPI.getRutasGuardado();
      setRutas(response.data || []);
    } catch {
      setError('Error al cargar las rutas');
    } finally {
      setLoading(false);
    }
  }, []);

  const guardarRuta = useCallback(async (data) => {
    setLoading(true);
    setError('');
    try {
      await obrasSocialesAPI.guardarRutaGuardado(data);
      await cargarRutas();
    } catch {
      setError('Error al guardar la ruta');
      throw new Error('Error al guardar la ruta');
    } finally {
      setLoading(false);
    }
  }, [cargarRutas]);

  const actualizarRuta = useCallback(async (id, data) => {
    setLoading(true);
    setError('');
    try {
      await obrasSocialesAPI.actualizarRutaGuardado(id, data);
      await cargarRutas();
    } catch {
      setError('Error al actualizar la ruta');
      throw new Error('Error al actualizar la ruta');
    } finally {
      setLoading(false);
    }
  }, [cargarRutas]);

  const eliminarRuta = useCallback(async (id) => {
    setLoading(true);
    setError('');
    try {
      await obrasSocialesAPI.eliminarRutaGuardado(id);
      await cargarRutas();
    } catch {
      setError('Error al eliminar la ruta');
    } finally {
      setLoading(false);
    }
  }, [cargarRutas]);

  return { rutas, loading, error, setError, cargarRutas, guardarRuta, actualizarRuta, eliminarRuta };
};
